module.exports = __webpack_public_path__ + "static/media/lco_logo.9b9abb8a.png";